import { GridCellProps } from '@progress/kendo-react-grid';
import { AdminTextField } from 'app/components/AdminTextField';
import React from 'react';
import { RiderPoint, SponsorList } from 'services/openapi';
import styled from 'styled-components';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
  setSponserName?: React.Dispatch<React.SetStateAction<string>>;
  sponserName?: string;
  disabled?: boolean | undefined;
  setSponserDataArray?: React.Dispatch<
    React.SetStateAction<SponsorList[] | undefined>
  >;
  sponserDataArray?: SponsorList[] | undefined;
  onPointChange: (point: RiderPoint) => void;
  resetKey: number;
};

export const ShowsScoreActionCell = ({
  className,
  e,
  onPointChange,
  resetKey,
}: Props) => {
  let dataDafault = e.dataItem;
  let teamPoint = e.dataItem.totalPoints;
  const initialValue = teamPoint ? teamPoint.toString() : '';
  const [data, setData] = React.useState<string>(initialValue);

  React.useEffect(() => {
    setData(initialValue);
  }, [resetKey]);

  const handleOnChange = e => {
    const inputValue = e.target.value;

    if (inputValue.length <= 5 && /^\d*$/.test(inputValue)) {
      setData(inputValue);
      const point: RiderPoint = {
        showRiderId: dataDafault.showRiderId,
        statsDate: dataDafault.showDate,
        totalPoints:
          inputValue === '' ? undefined : (parseFloat(inputValue) as number),
        teamTransferStatus: false,
      };
      onPointChange(point);
    }
  };

  return (
    <td className={className ?? ''}>
      <MainWrapper>
        <AdminTextField
          onChange={e => handleOnChange(e)}
          value={data}
          type="text"
          onKeyDown={e => {
            if (['e', 'E', '+', '-'].includes(e.key)) {
              e.preventDefault();
            }
          }}
        ></AdminTextField>
      </MainWrapper>
    </td>
  );
};

const MainWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .tooltip-style{
    max-width: 70px;
    input{
    max-height: 31px;
    }
  }
`;
